import type { SearchOrderCommoditiesRequest } from '@trukt/tms-api/OrderService';
import { createKey } from '../../createKey';

const keyHandler = createKey('order-commodity');

export const OrderCommodityServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<SearchOrderCommoditiesRequest>(),
};
